export interface Testimonial {
  id: number;
  name: string;
  role: string;
  content: string;
  avatar: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: '柚子',
    role: '资深女仆，从业5年',
    content: '"女仆不只是工作"这个平台让我看到了行业的更多可能性。每一篇文章都在提醒我——我所做的工作，不仅仅是端咖啡那么简单，而是在为都市人提供一份稀缺的温暖和陪伴。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Asian%20woman%20with%20sweet%20warm%20smile%2C%20minimalist%20cream%20backdrop%2C%20soft%20natural%20light%2C%20editorial%20headshot&width=160&height=160&seq=testimonial-yuzu&orientation=squarish',
  },
  {
    id: 2,
    name: '王先生',
    role: '常客，IT行业从业者',
    content: '作为女仆咖啡厅的常客，我一直在寻找能够理解这种文化的深度内容。"女仆不只是工作"不仅是理解，更是升华。每一篇常客故事都让我感同身受。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20middle%20aged%20Asian%20man%20with%20kind%20expression%2C%20minimalist%20cream%20backdrop%2C%20warm%20lighting%2C%20editorial%20headshot&width=160&height=160&seq=testimonial-wang&orientation=squarish',
  },
  {
    id: 3,
    name: '小美',
    role: '前女仆从业者，现互联网从业者',
    content: '即使已经转行，我依然每周阅读这个网站的更新。它让我记住那段特别的时光——在女仆咖啡厅的两年，是我人生中成长最快的两年。感谢这个平台让更多人理解我们的故事。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Asian%20woman%20with%20professional%20modern%20style%2C%20minimalist%20cream%20backdrop%2C%20warm%20lighting%2C%20editorial%20headshot&width=160&height=160&seq=testimonial-xiaomei&orientation=squarish',
  },
  {
    id: 4,
    name: '李女士',
    role: '商务人士，女仆文化爱好者',
    content: '第一次发现这个网站时，我读了整整一个下午。那些关于女仆角色认同和情感连接的文章，不仅增进了我对女仆文化的理解，更让我反思了自己在职场中的角色认同。深度内容的力量在于，它总能让你看到更大的世界。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20mature%20Asian%20woman%20with%20elegant%20style%2C%20minimalist%20cream%20backdrop%2C%20warm%20lighting%2C%20editorial%20headshot&width=160&height=160&seq=testimonial-li&orientation=squarish',
  },
  {
    id: 5,
    name: '动漫观察员小A',
    role: '二次元文化研究者',
    content: '作为研究者，我高度评价这个平台的内容质量。它不只是粉丝向的浅层介绍，而是真正从文化研究的角度深度解析女仆现象。从心理学到社会学，从服装史到粉丝文化，每一篇文章都有扎实的学术基础。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Asian%20person%20with%20glasses%20and%20scholarly%20style%2C%20minimalist%20cream%20backdrop%2C%20warm%20lighting%2C%20editorial%20headshot&width=160&height=160&seq=testimonial-anime&orientation=squarish',
  },
  {
    id: 6,
    name: '小雪',
    role: '新手女仆，刚入职3个月',
    content: '"女仆不只是工作"在我最迷茫的时候给了我力量。入职第一个月我差点放弃，是这里的前辈故事让我坚持了下来。现在每天穿上围裙的时候，我都会想起那句——温柔是一种力量，而不是软弱。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Asian%20woman%20with%20fresh%20natural%20beauty%2C%20minimalist%20cream%20backdrop%2C%20warm%20lighting%2C%20editorial%20headshot&width=160&height=160&seq=testimonial-xiaoxue&orientation=squarish',
  },
];